import React from 'react'
import Button from '@components/common/Button/Button.component'

export function renderOverviewTableActionsCell(): React.ReactNode {
  return (
    <div className="action-buttons">
      <Button type="button" className="action-button-filled">
        <i className="mgc mgc_phone_fill" aria-hidden />
      </Button>
      <Button type="button" className="action-button" disabled>
        <i className="ti ti-mail-filled" aria-hidden />
      </Button>
      <Button type="button" className="action-button">
        <i className="ti ti-message-filled" aria-hidden />
      </Button>
    </div>
  )
}
